export function isHorizontal(placement) {
    switch (placement) {
        case 'top': return false;
        case 'bottom': return false;
        case 'right': return true;
        case 'left': return true;
    }
}
export const isVertical = (placement) => !isHorizontal(placement);